import IncomeShowPrint from './income-show-print.vue'
export default {
    components:{
        IncomeShowPrint
    },
    props  : {
        form_id: null
    },
    data   : () => ({
        item          : {
            warehouse  : {},
            transaction: {
                bank    : {},
                account : {},
                userable: {}
            },
        },
        paymentHeaders: [
            {text: 'date', value: 'date', sortable: true},
            {text: 'paid', value: 'paid', sortable: true},
            {text: 'mood', value: 'transaction.payment_method', sortable: true},
            {text: 'bank', value: 'transaction.bank.name', sortable: true},
        ]
    }),
    created() {
        if(this.form_id) {
            this.getData()
        }
    },
    methods: {
        getData() {
            axios
                .get('/api/income/incomes/' + this.form_id)
                .then(res => {
                    this.item = res.data
                })
        }
    }
}